import {cloneObject, getRoutePath, hotelRoutePush} from "@/common/utility/utils";
import HotelOrder from "@/common/model/hotel/hotelOrder";
import {
  kpiCacheSet,
  kpiHotelGetInterHotelFilterCondition
} from 'api'
import {mixinHotelGetPriceAndStar} from "@/components/c-filter/c-hotel-price-star";
import mixinFilterHotelHome from "@/common/mixin/hotel/mixin-filter-hotel-home";
import {INTER_YESTERDAY_CLOSE_HOURS, YESTERDAY_CLOSE_HOURS} from "@/common/constants/common";
export default {
  data() {
    return {
      hotelOptions: [this.$t('ChinaRegion'), this.$t('International')],
      /** 国内酒店订单 */
      dHotelOrder: new HotelOrder(),
      /** 国际酒店订单 */
      iHotelOrder: new HotelOrder(),

      showHotelAddressPicker: false,
      hotelTabActiveIndex: 0,

      showHotelDatePicker: false,
      checkInDate: this.beTime(new Date()), // 入住日期
      checkOutDate: this.beTime(new Date().setDate(new Date().getDate() + 1)), // 离店日期

      QueryText: {},
      showHotelStarAndPrice: false, // 星级价格筛选弹框
      showHotelFilter: false, // 关键字品牌商圈搜索
      filterDetails: [],

      interQueryText: {},
      showInterCHotelFilterAlert: false, // 国际酒店关键字品牌商圈搜索
      showInterStarAndPriceDialog: false, // 国际酒店价格星级
      interFilterDetails: [],

      showCCheckRoom: false,
      RoomAmount: 1,
      AdultAmount: 2,
      ChildAmount: 0,
      ChildAges: [],
    }
  },
  computed: {
    hasHotelAndIntlHotel() {
      let val = false
      if (this.TravelType === 0) {
        val = this.hasPower('因公:酒店:国内酒店查询') && this.hasPower('因公:酒店:国际酒店查询')
      } else {
        val = this.hasPower('因私:国内酒店') && this.hasPower('因私:国际酒店')
      }
      return val
    },
    choosePassengerFirst4Hotel() {
      return Number(this.TravelType) === 0 && Number(this.getSetting('国内酒店配置:正常订单:查询顺序')) === 1
    },
    choosePassengerFirst4IntlHotel() {
      return Number(this.TravelType) === 0 && Number(this.getSetting('国际酒店配置:正常订单:查询顺序')) === 1
    },
    YesterdayCloseHours() {
      // 酒店凌晨入住时间
      let YesterdayCloseHours = YESTERDAY_CLOSE_HOURS
      if (this.hotelTabActiveIndex === 1) {
        YesterdayCloseHours = INTER_YESTERDAY_CLOSE_HOURS
      }
      return YesterdayCloseHours
    },
    hotelCityName() {
      let {dHotelOrder, iHotelOrder, hotelTabActiveIndex} = this
      let val = ''
      if (hotelTabActiveIndex === 0) {
        if (dHotelOrder.Longitude && dHotelOrder.Latitude && dHotelOrder.Address) {
          val = dHotelOrder.Address
        } else if (dHotelOrder.City && this.getCityName(dHotelOrder.City)) {
          val = this.getCityName(dHotelOrder.City)
        }
      } else {
        if (iHotelOrder.City && this.getCityName(iHotelOrder.City)) {
          val = this.getCityName(iHotelOrder.City)
        }
      }
      return val
    },
    hotelOverdueDate() {
      let val = this.beTime(new Date())
      if (this.isInterHotel) {
        val = this.getNewDate(this.beTime(new Date()), 0, 0, -1)
      }
      return val
    },
    isInterHotel() { // 海外酒店
      return this.hotelOptions[this.hotelTabActiveIndex] === this.$t('International')
    },
    /** 商圈 str */
    HotelBusinessDistrictBrand() {
      let val = this.QueryText ? this.QueryText.Name : ''
      if (this.isInterHotel) {
        val = this.interQueryText ? this.interQueryText.Name : ''
      }
      return val
    },
    // 价格星级 展示str
    hotelPriceAndStarText() {
      let val = ''
      if (this.isInterHotel) {
        val = mixinHotelGetPriceAndStar(this.iHotelOrder.StarRate, {
          LowRate: this.iHotelOrder.LowRate,
          HighRate: this.iHotelOrder.HighRate,
        }, true)
      } else {
        val = mixinHotelGetPriceAndStar(this.dHotelOrder.StarRate, this.dHotelOrder)
      }
      return val
    }
  },
  mixins: [mixinFilterHotelHome],
  methods: {
    mixinHotelInitInfo(type) {
      if (type === 2) {
        this.mixinHotelGetDateStorage()
      } else {
        this.mixinHotelGetDateStorage()
      }
    },

    /** 初始化酒店权限 */
    mixinHotelInitPersonalPower() {
      let oldVal = this.hotelTabActiveIndex
      // 因公
      let hasBusHotel = this.hasPower('因公:酒店:国内酒店查询')
      let hasBusInterHotel = this.hasPower('因公:酒店:国际酒店查询')
      let hasPerHotel = this.hasPower('因私:国内酒店')
      let hasPerInterHotel = this.hasPower('因私:国际酒店')
      if (Number(this.TravelType) === 0) {
        if (this.hasPower('因公:酒店')) {
          if (!hasBusHotel && !hasBusInterHotel) {

          } if (!hasBusHotel) {
            this.hotelTabActiveIndex = 1
          } else if (!hasBusInterHotel) {
            this.hotelTabActiveIndex = 0
          }
        }
      } else {
        if (this.hasPower('因私')) {
          if (!hasPerHotel && !hasPerInterHotel) {

          } else if (!hasPerHotel) {
            this.hotelTabActiveIndex = 1
          } else if (!hasPerInterHotel) {
            this.hotelTabActiveIndex = 0
          }
        }
      }

      // 因公因私切换时
      if (oldVal !== this.hotelTabActiveIndex) {
        this.mixinHotelTabSelect(this.hotelTabActiveIndex)
      }
    },

    /** 国内海外酒店切换 */
    mixinHotelTabSelect(index = 0) {
      this.hotelTabActiveIndex = index
      // 国内、海外酒店切换时校验日期是否符合要求，否则更新日期
      this.mixinHotelSetFromDate(this.checkInDate)
      this.mixinHotelSetToDate(this.checkOutDate)
    },

    /** 酒店地址点击 */
    mixinHotelClickDeparture() {
      this.showHotelAddressPicker = true
    },

    /** 国内酒店定位 */
    mixinHotelLocation() {
      this.$refs.RefsHotelAddressPicker && this.$refs.RefsHotelAddressPicker.getLocation()
    },

    /** 地址选择器回调 */
    mixinHotelSetCity(val, type) {
      if (!this.isInterHotel) {
        let oldCityID = this.dHotelOrder.CityID
        this.dHotelOrder.City = val
        this.dHotelOrder.CityName = this.getCityName(val)
        this.dHotelOrder.CityID = val ? val.CityCode : ''
        this.mixinHotelSetStorage()
        this.mixinHotelClearQueryText(val, type, oldCityID) // 清空筛选条件
        // 重置
        this.dHotelOrder.Longitude = null
        this.dHotelOrder.Latitude = null
        this.dHotelOrder.Address = null
        type && type === 'hotelSearchSelected' && this.mixinHotelJumpHotelList(val)
      } else {
        let oldCityID = this.iHotelOrder.CityID
        this.iHotelOrder.City = val
        this.iHotelOrder.CityName = this.getCityName(val)
        this.iHotelOrder.CityID = val ? val.CityCode : ''
        this.mixinHotelSetStorage()
        this.mixinHotelClearQueryText(val, type, oldCityID) // 清空筛选条件
        type && type === 'hotelSearchSelected' && this.mixinHotelJumpHotelList(val)
      }
    },

    /** 酒店日期点击回调 */
    mixinHotelClickDate() {
      this.showHotelDatePicker = true
    },

    /** 日期选择回调 */
    mixinHotelSetFromDate(val) {
      // let today = this.beTime(new Date())
      let limitDate = this.beTime(new Date())
      if (this.isInterHotel) {
        limitDate = this.getNewDate(this.beTime(new Date()), 0, 0, -1)
      }
      if (val && val < limitDate && !this.mixinHotelIsCanBookPreDay(val)) {
        this.checkInDate = this.mixinHotelIsBeforeDawn() ? this.getNewDate(limitDate, 0, 0, -1) :limitDate
      } else {
        this.checkInDate = val
      }
      this.mixinHotelSetStorage()
    },

    /** 离店日期回调 */
    mixinHotelSetToDate(val) {
      if (val && val <= this.checkInDate) {
        this.checkOutDate = this.getNewDate(this.checkInDate, 0, 0, 1)
      } else {
        this.checkOutDate = val
      }
      this.mixinHotelSetStorage()
    },

    /** 定位回调 */
    mixinHotelSetAddressWidthLngLat(lng, lat, address) {
      this.dHotelOrder.Longitude = lng
      this.dHotelOrder.Latitude = lat
      this.dHotelOrder.Address = address

      // 定位成功后 清空关键词
      this.mixinHotelClearFilterDetails({})
    },

    /** 根据城市选择结果清空筛选条件 */
    mixinHotelClearQueryText(val, type, oldCityID) {
      /** 国内酒店城市 搜索结果选中触发的回调 需更新关键词 */
      if (type && type === 'hotelSearchSelected') {
        if (val.Type !== 11) { // 非 城市类型则 更新选中条件
          this.mixinHotelClearFilterDetails(val.Id ? val : {
            Id: null,
            Latitude: null,
            Longitude: null,
            Name: val.Name,
            CityID: val.CityID,
            Type: 'other',
            FilterType: '',
            selected: false
          })
        } else { // 城市类型则判断城市是否变化 城市未变化则不清空
          if (!this.mixinHotelCheckIsSameCity(val.CityID || val.CityCode, oldCityID)) {
            this.mixinHotelClearFilterDetails({})
          }
        }
      } else { // 城市类型则判断城市是否变化 城市未变化则不清空
        if (!this.mixinHotelCheckIsSameCity(val.CityID || val.CityCode, oldCityID)) {
          this.mixinHotelClearFilterDetails({})
        }
      }
    },

    /** 校验是否相同城市 */
    mixinHotelCheckIsSameCity(CityID, oldCityID) {
      return String(CityID) === String(oldCityID)
    },

    /** 清空筛选条件 */
    mixinHotelClearFilterDetails(QueryText) {
      if (this.hotelTabActiveIndex === 0) {
        this.QueryText = QueryText
        this.dHotelOrder.Filters = []
      } else {
        this.interQueryText = QueryText
        this.iHotelOrder.Filters = []
      }
    },

    /** 酒店商圈点击 */
    mixinHotelClickFilterDetails() {
      if (this.isInterHotel && !this.iHotelOrder.CityID) {
        this.$toast(this.$t('PleaseSelectADestination'))
        return
      } else if (!this.isInterHotel && !this.dHotelOrder.CityID) {
        this.$toast(this.$t('PleaseSelectADestination'))
        return
      }
      this.showHotelFilter = true
    },

    /** 酒店商圈筛选回调 */
    async mixinHotelSetFilterDetails(list, item, key) {
      if (this.hotelTabActiveIndex === 0) {
        let oldCityID = this.dHotelOrder.CityID
        if (item.Type === 11) { // 如果返回结果是城市类型的 则更新城市 清空选中条件
          if (item.CityCode && !this.mixinHotelCheckIsSameCity(item.CityCode, oldCityID)) {
            this.QueryText = {}
          }
        } else {
          this.QueryText = item
        }
        /** 当CityCode 存在 且 城市发生变化 更新城市信息 并更新筛选条件 */
        // 国内酒店商圈选中时更新
        if (item && item.CityCode) {
          this.dHotelOrder.City = item
          this.dHotelOrder.CityName = this.getCityName(item)
          this.dHotelOrder.CityID = item ? item.CityCode : ''
          // 重置
          this.dHotelOrder.Longitude = null
          this.dHotelOrder.Latitude = null
          this.dHotelOrder.Address = null
          this.mixinHotelSetStorage()
        }

        this.mixinHotelJumpHotelList(item)
      } else {
        let oldCityID = this.iHotelOrder.CityID
        if (item.Type === 11) { // 如果返回结果是城市类型的 则更新城市 清空选中条件
          if (item.CityCode && !this.mixinHotelCheckIsSameCity(item.CityCode, oldCityID)) {
            this.interQueryText = {}
          }
        } else {
          this.interQueryText = item
        }
        /** 当CityCode 存在 且 城市发生变化 更新城市信息 并更新筛选条件 */
        // 国内酒店商圈选中时更新
        if (item && item.CityCode) {
          this.iHotelOrder.City = item
          this.iHotelOrder.CityName = this.getCityName(item)
          this.iHotelOrder.CityID = item ? item.CityCode : ''
          // 重置
          this.iHotelOrder.Longitude = null
          this.iHotelOrder.Latitude = null
          this.iHotelOrder.Address = null
          this.mixinHotelSetStorage()
        }
        this.mixinHotelJumpHotelList(item)
      }
    },

    /** 清空价格星级 */
    mixinHotelPriceAndStar() {
      if (this.isInterHotel) {
        this.iHotelOrder.LowRate = 0
        this.iHotelOrder.HighRate = undefined
        this.iHotelOrder.StarRate = ''
      } else {
        this.dHotelOrder.LowRate = 0
        this.dHotelOrder.HighRate = undefined
        this.dHotelOrder.StarRate = ''
      }
    },

    /** 星级价格选中回调 */
    mixinHotelSetPriceAndStar(priceList, StarRate) {
      if (this.isInterHotel) {
        this.iHotelOrder.LowRate = priceList[0]
        this.iHotelOrder.HighRate = priceList[1]
        this.iHotelOrder.StarRate = StarRate
      } else {
        this.dHotelOrder.LowRate = priceList[0]
        this.dHotelOrder.HighRate = priceList[1]
        this.dHotelOrder.StarRate = StarRate
      }
    },

    /** 酒店房间数 入住人数点击 */
    mixinHotelRoomAdultClick() {
      this.showCCheckRoom = true
    },

    // 酒店房间数入住人数回调
    mixinCheckRoomCallback(RoomNum, AdultNum, ChildNum, ages) {
      this.RoomAmount = RoomNum
      this.AdultAmount = AdultNum
      this.ChildAmount = ChildNum
      this.ChildAges = ages
    },

    /** 选中酒店 触发校验 跳转下一页 */
    mixinHotelJumpHotelList(item) {
      if (Number(item.Type) === 1) {
        this.mixinHotelGoQuery()
      }
    },

    /** 酒店下一步去查询接口 */
    mixinHotelGoQuery(Passengers) {
      if (this.hotelTabActiveIndex === 0) {
        if (this.noValue(this.dHotelOrder.CityID)) {
          this.$toast(this.$t('PleaseSelectADestination'))
          return
        } else if (this.noValue(this.checkInDate)) {
          this.$toast(this.$t('PleaseSelectedTheCheckInDate'))
          return
        } else if (this.noValue(this.checkOutDate)) {
          this.$toast(this.$t(`PleaseSelect_x`, 'function', [this.$t('CheckOutDate')]))
          return
        } else if (!this.mixinHotelCheckInDate(this.checkInDate)) {
          this.$toast(this.$t('PleaseReselectYourCheckInDate'))
          return
        }
        // console.log('2021-11-14, 18 false 校验不通过', this._checkCheckInDate('2021-11-14', '18'))
        // console.log('2021-11-14, 0 false 校验不通过', this._checkCheckInDate('2021-11-14', 0))
        // console.log('2021-11-15, 18 true 校验通过', this._checkCheckInDate('2021-11-15', '18'))
        // console.log('2021-11-15, 0 false 校验不通过', this._checkCheckInDate('2021-11-14', 0))
        // console.log('2021-11-15, 15 false 校验不通过', this._checkCheckInDate('2021-11-15', '15'))
        // console.log('2021-11-16, 18 true 校验通过', this._checkCheckInDate('2021-11-16', '18'))
        // console.log('2021-11-16, 0 true 校验通过', this._checkCheckInDate('2021-11-16', 0))
        this.dHotelOrder.TravelType = this.TravelType
        this.dHotelOrder.CheckInDate = this.checkInDate
        this.dHotelOrder.CheckOutDate = this.checkOutDate
        this.dHotelOrder.QueryText = this.QueryText
        this.dHotelOrder.RoomAmount = this.RoomAmount
        this.dHotelOrder.AdultAmount = this.AdultAmount
        this.dHotelOrder.ChildAmount = this.ChildAmount
        this.dHotelOrder.ChildAges = this.ChildAges
        this.dHotelOrder.choosePassengerFirst = Number(this.TravelType) === 0 ? this.choosePassengerFirst4Hotel : false
        this.dHotelOrder.hotelCanBookPreDay = this.mixinHotelIsBeforeDawn() // 是否可以选择凌晨入住
        this.dHotelOrder.YesterdayCloseHours = this.YesterdayCloseHours // 是否可以选择凌晨入住
        this.mixinSelectGuests([])
      } else {
        this.iHotelOrder.TravelType = this.TravelType
        this.iHotelOrder.CheckInDate = this.checkInDate
        this.iHotelOrder.CheckOutDate = this.checkOutDate
        this.iHotelOrder.QueryText = this.interQueryText
        this.iHotelOrder.RoomAmount = this.RoomAmount
        this.iHotelOrder.AdultAmount = this.AdultAmount
        this.iHotelOrder.ChildAmount = this.ChildAmount
        this.iHotelOrder.ChildAges = this.ChildAges
        this.iHotelOrder.choosePassengerFirst = Number(this.TravelType) === 0 ? this.choosePassengerFirst4IntlHotel : false
        this.iHotelOrder.hotelCanBookPreDay = this.mixinHotelIsBeforeDawn() // 是否可以选择凌晨入住
        this.iHotelOrder.YesterdayCloseHours = this.YesterdayCloseHours // 是否可以选择凌晨入住
        if (this.noValue(this.iHotelOrder.CityID)) {
          this.$toast(this.$t('PleaseSelectADestination'))
          return
        } else if (this.noValue(this.checkInDate)) {
          this.$toast(this.$t('PleaseSelectedTheCheckInDate'))
          return
        } else if (this.noValue(this.checkOutDate)) {
          this.$toast(this.$t(`PleaseSelect_x`, 'function', [this.$t('CheckOutDate')]))
          return
        } else if (!this.mixinHotelCheckInDate(this.checkInDate)) {
          this.$toast(this.$t('PleaseReselectYourCheckInDate'))
          return
        }
        this.mixinSelectIntlGuests([])
      }
    },

    // 国内酒店先选人判断
    mixinSelectGuests (Guests) {
      this.dHotelOrder.Guests = []
      if (this.dHotelOrder.choosePassengerFirst && Guests.length <= 0) {
        this.$refs.RefsCPassenger && this.$refs.RefsCPassenger.open()
        return
      } else {
        this.dHotelOrder.Guests = Guests
        this.mixinGoToHotelList()
      }
    },

    // 跳转国内酒店列表
    mixinGoToHotelList() {
      let params = {
        CacheKey: `dh${Number(new Date())}`,
        CacheValue: JSON.stringify(this.dHotelOrder)
      }
      kpiCacheSet(params).then((res) => {
        hotelRoutePush(getRoutePath({path: '/hotel/inforList', query: {tmp: params.CacheKey, back: 1}}))
      })
    },

    // 如果是oa 或先选人则要选人
    mixinSelectIntlGuests (Guests) {
      this.iHotelOrder.Guests = []
      if (this.iHotelOrder.choosePassengerFirst && Guests.length <= 0) {
        this.$refs.RefsCPassenger && this.$refs.RefsCPassenger.open()
        return
      } else {
        this.iHotelOrder.Guests = Guests
        this.mixinGoToIntelHotelList()
      }
    },

    // 跳转海外酒店起价列表页
    mixinGoToIntelHotelList () {
      let params = {
        CacheKey: `ih${Number(new Date())}`,
        CacheValue: JSON.stringify(this.iHotelOrder)
      }
      kpiCacheSet(params).then(() => {
        hotelRoutePush(getRoutePath({path: '/intlHotel/inforList', query: {tmp: params.CacheKey, back: 1}}))
      })
    },

    /** 更新缓存的是否可以预定昨天展示 */
    mixinHotelSetStorageCanBookPreDay(day) {
      let key = 'hotelCanBookPreDay'
      window.localStorage.removeItem(key)
      if (this.mixinHotelIsCanBookPreDay(day || this.currentFromDate)) { // 是否可以下昨天的单
        window.localStorage.setItem(key, 'true')
      } else {
        window.localStorage.removeItem(key)
      }
    },

    /** 设置缓存 */
    mixinHotelSetStorage() {
      let CityVersion = window.localStorage.CityVersion ? JSON.parse(window.localStorage.CityVersion) : {}
      if (this.isInterHotel) {
        window.localStorage.HISTORY_QUERY_INTL_HOTEL = JSON.stringify({
          CityVersion: CityVersion.IntlHotelCityVersionV2,
          City: this.iHotelOrder.City,
          CheckInDate: this.checkInDate,
          CheckOutDate: this.checkOutDate
        })
        // 同步国内国际日期缓存
        if (window.localStorage.HISTORY_QUERY_DOMESTIC_HOTEL) {
          window.localStorage.HISTORY_QUERY_DOMESTIC_HOTEL = JSON.stringify({
            ...this.mixinHotelHandlerStory(window.localStorage.HISTORY_QUERY_DOMESTIC_HOTEL),
            CheckInDate: this.checkInDate,
            CheckOutDate: this.checkOutDate
          })
        }
        // 国际
      } else {
        window.localStorage.HISTORY_QUERY_DOMESTIC_HOTEL = JSON.stringify({
          City: this.dHotelOrder.City,
          CheckInDate: this.checkInDate,
          CheckOutDate: this.checkOutDate
        })
        // 同步国内国际日期缓存
        if (window.localStorage.HISTORY_QUERY_INTL_HOTEL) {
          window.localStorage.HISTORY_QUERY_INTL_HOTEL = JSON.stringify({
            ...this.mixinHotelHandlerStory(window.localStorage.HISTORY_QUERY_INTL_HOTEL),
            CityVersion: CityVersion.IntlHotelCityVersionV2,
            CheckInDate: this.checkInDate,
            CheckOutDate: this.checkOutDate
          })
        }
      }
    },

    mixinHotelHandlerStory(obj) {
      return JSON.parse(obj)
    },

    // 读取城市缓存
    mixinHotelGetCityStorage() {
      // 初始化时不管当前选中项是国内、海外酒店 城市读取缓存
      if (window.localStorage.HISTORY_QUERY_DOMESTIC_HOTEL) {
        let val = JSON.parse(window.localStorage.HISTORY_QUERY_DOMESTIC_HOTEL)
        this.dHotelOrder.City = val.City
        this.dHotelOrder.CityName = this.getCityName(val.City)
        this.dHotelOrder.CityID = val.City ? val.City.CityCode : ''

        this.dHotelOrder.Longitude = null
        this.dHotelOrder.Latitude = null
        this.dHotelOrder.Address = null
      }
      if (window.localStorage.HISTORY_QUERY_INTL_HOTEL) {
        let val = JSON.parse(window.localStorage.HISTORY_QUERY_INTL_HOTEL)
        let CityVersion = window.localStorage.CityVersion ? JSON.parse(window.localStorage.CityVersion) : {}
        if (val.CityVersion && val.CityVersion === CityVersion.IntlHotelCityVersionV2) { // 缓存的城市版本号不存在则表示当前城市缓存是老的不可用
          this.iHotelOrder.City = val.City
          this.iHotelOrder.CityName = this.getCityName(val.City)
          this.iHotelOrder.CityID = val.City ? val.City.CityCode : ''
        }
      }
    },

    // 读取缓存
    mixinHotelGetDateStorage() {
      let minEffectiveDate = this.getMinEffectiveDate()
      if (this.hotelTabActiveIndex === 0 && window.localStorage.HISTORY_QUERY_DOMESTIC_HOTEL) {
        let val = JSON.parse(window.localStorage.HISTORY_QUERY_DOMESTIC_HOTEL)
        this.checkInDate = this.mixinFixedDate(val.CheckInDate, minEffectiveDate)
        this.checkOutDate = this.mixinFixedDate(val.CheckOutDate, this.checkInDate, this.getNewDate(this.checkInDate, 0, 0, +1))
      } else if (this.hotelTabActiveIndex === 1 && window.localStorage.HISTORY_QUERY_INTL_HOTEL) {
        let val = JSON.parse(window.localStorage.HISTORY_QUERY_INTL_HOTEL)
        this.checkInDate = this.mixinFixedDate(val.CheckInDate, minEffectiveDate)
        this.checkOutDate = this.mixinFixedDate(val.CheckOutDate, this.checkInDate, this.getNewDate(this.checkInDate, 0, 0, +1))
      } else {
        if (this.CheckInDate && this.CheckOutDate) {
        } else {
          this.mixinHotelSetDefaultDay()
        }
      }
    },

    // 修正日期
    mixinFixedDate(date, limitDate, canSetDate) {
      return date <= limitDate ? (canSetDate || limitDate) : date
    },

    /** 最小有效日期 */
    getMinEffectiveDate () {
      let today = this.beTime(new Date())
      let limitDate = today
      if (this.isInterHotel) {
        limitDate = this.getNewDate(this.beTime(new Date()), 0, 0, -1)
      }
      let hours = new Date().getHours();
      let limit = this.YesterdayCloseHours
      if (limit > 0 && hours < limit) {
        return this.getNewDate(today, 0, 0, -1)
      }
      return limitDate
    },

    // 初始化默认时间
    mixinHotelSetDefaultDay() {
      if (this.mixinHotelIsBeforeDawn()) {
        this.checkInDate = this.getNewDate(this.beTime(new Date()), 0, 0, -1)
        this.checkOutDate = this.beTime(new Date())
      } else {
        this.checkInDate = this.beTime(new Date())
        this.checkOutDate = this.getNewDate(this.beTime(new Date()), 0, 0, +1)
      }
    },

    // 校验入住日期 是否小与当前日期
    mixinHotelCheckInDate(date, YesterdayCloseHours = this.YesterdayCloseHours) {
      let nowDate = this.beTime(new Date(), 'yyyy-MM-dd')
      let preDate = this.getNewDate(nowDate, 0, 0, -1)
      let hours = new Date().getHours()
      // 如果date是 昨天 切 当前时间大于YesterdayCloseHours 不可查询
      if (date < nowDate) {
        if (date === preDate) {
          if (YesterdayCloseHours && YesterdayCloseHours > 0 && hours > YesterdayCloseHours) {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      }
      return true
    },

    /** 是否可以下昨天的单 */
    mixinHotelIsCanBookPreDay(date) {
      if (!date) {
        return false
      }
      let yesterday = this.getNewDate(new Date(), 0, 0, -1)
      if (this.beTime(date) === this.beTime(yesterday) && this.mixinHotelIsBeforeDawn()) {
        return true
      }
      return false
    },

    /** 是否有凌晨下单时间点 且当前时间小于凌晨时间点 */
    mixinHotelIsBeforeDawn() {
      let hours = new Date().getHours()
      return this.YesterdayCloseHours > 0 && hours < this.YesterdayCloseHours
    }
  }
}
